/** EvPopup defaults to 450px, which clips a long seed URL while it is typed. */
export const CREATE_PROPERTY_POPUP_WIDTH = 800;
